document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('.product-card__image img');

    function resizeThumbnails() {
        images.forEach(img => {
            const container = img.closest('.product-card__image');
            const containerHeight = container.offsetHeight;

            // Apply a consistent height to the image if it's not already set
            img.style.height = `${containerHeight}px`;
            img.style.width = 'auto';
            img.style.objectFit = 'cover';
        });
    }

    // Call the function to resize images
    resizeThumbnails();

    // In case the window resizes, call the function again
    window.addEventListener('resize', resizeThumbnails);
});